<ng-container *ngIf="id">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    (click)="onContextMenu($event)"
  >
    <path
      d="M10.0002 6.66659C10.9168 6.66659 11.6668 5.91659 11.6668 4.99992C11.6668 4.08325 10.9168 3.33325 10.0002 3.33325C9.0835 3.33325 8.3335 4.08325 8.3335 4.99992C8.3335 5.91659 9.0835 6.66659 10.0002 6.66659ZM10.0002 8.33325C9.0835 8.33325 8.3335 9.08325 8.3335 9.99992C8.3335 10.9166 9.0835 11.6666 10.0002 11.6666C10.9168 11.6666 11.6668 10.9166 11.6668 9.99992C11.6668 9.08325 10.9168 8.33325 10.0002 8.33325ZM10.0002 13.3333C9.0835 13.3333 8.3335 14.0833 8.3335 14.9999C8.3335 15.9166 9.0835 16.6666 10.0002 16.6666C10.9168 16.6666 11.6668 15.9166 11.6668 14.9999C11.6668 14.0833 10.9168 13.3333 10.0002 13.3333Z"
      fill="black"
      fill-opacity="0.6"
    />
  </svg>

  <context-menu
    [menuClass]="'external-mam-context-menu'"
    (close)="this.contextMenuOpen = false"
  >
    <ng-template contextMenuItem (execute)="Import()">Import</ng-template>
    <ng-template *ngIf="imported" contextMenuItem (execute)="UpdateMetadata()"
      >Update Metadata</ng-template
    >
  </context-menu>
</ng-container>
